export enum ErrorsCode {
  ENTITY_DOES_NOT_EXIST = 1001,
  ENTITY_ALREADY_EXISTS = 1002,
  PERMISSION_DENIED = 1003,
  INVALID_REQUEST = 1004,
  NO_AVAILABILITIES_FOUND = 1005,
  TICKET_CREATION = 1006,
  PAYMENT = 1007,
  MAX_CAPACITY = 1008,
  UNFEASIBLE_BOOKING = 1009,
  INVALID_TRIP_STATUS = 1010,
  DATABASE_CONFLICT = 1011,
  MESSAGE_TYPE_NOT_ENABLED = 1012,
  PASSWORD_REPEATED = 1013,
  ENTITY_IN_USE = 1014,
  ENTITY_ALREADY_ASSIGNED = 1015,

  // SERVICES
  NO_UNIQUE_PATH = 2001,
  NO_PATH = 2002,
  START_OR_END_MISSING = 2003,
  WRONG_TICKETING_TYPE = 2004,
  STOP_IN_USE = 2005,
  START_OR_END_ON_DYNAMIC = 2006,
  STOPS_MISSING_FROM_TOWN = 2007,
  ALTERATION_OVERLAP = 2007,
  STOP_NOT_IN_ROUTE = 2008,
  UNPLANNED_BOOKINGS = 2009,
  BOOKINGS_WOULD_BE_CANCELLED = 2010,
  ROUTE_HAS_BOOKINGS = 2011,
  DEPARTURE_NOT_PLANNED = 2012,
  DEPARTURE_SHORTER_THAN_MIN_PATH_TIME = 2013,
  SERVICE_INFO_HAS_BOOKINGS = 2014,
  EMPTY_WHITE_LIST = 2015,

  // SETUP
  REPEATED_DAY_OF_WEEK = 3001,
  
  // EXCEL IMPORT
  STOP_FAR_FROM_ROAD = 4004,
  STOP_DUPLICATED_ON_PATH = 4005,
  STOP_NOT_ON_SHEET = 4006,

  // TOWNS
  TOWN_HAS_BOOKINGS = 5001,

  // RESTRICTIONS AN ADMINISTRATOR MAY ACCEPT
  RESTRICTIONS_NOT_ACCEPTED = 5004,

  SCHEDULE_AVAILABILITY_CLOSED = 7001,
  SCHEDULE_TRIP_CLOSED = 7002,
  SCHEDULE_TRIP_ROUTE_MISMATCH = 7003,
  SCHEDULE_TRIP_OUTSIDE_AVAILABILITY = 7004,
  SCHEDULE_START_IN_PAST = 7005,
  SCHEDULE_ALREADY_STARTED = 7006,
  SCHEDULE_VEHICLE_SEATS_EXCEEDED = 7007,
  SCHEDULE_LINKED_CHANGE_FAILED = 7008,
  SCHEDULE_ASSIGNMENT_CLIENT_MISMATCH = 7009,
}
